import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import ChatIcon from '@/public/images/dashboard/chat.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function UnassignedInquiriesEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={ChatIcon}
      title={Trans(translations, 'HereYouWillSeeUnassignedReceivedInquiries')}
      description={Trans(
        translations,
        'PromotingYourPropertiesIsKeyToFindLeads'
      )}
    />
  );
}

export default UnassignedInquiriesEmptyState;
